import React from 'react'

export default () => (
  <svg
    width="auto"
    height="100%"
    viewBox="0 0 25 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clip-path="url(#clip0_5457_9838)">
      <g clip-path="url(#clip1_5457_9838)">
        <path
          d="M1.22935 5H11.7356C11.9257 5 12.0796 5.15032 12.0796 5.33597V10.1438C12.0796 10.444 11.9005 10.7165 11.6215 10.8413L10.2982 11.4345C10.2336 11.4636 10.1919 11.5266 10.1919 11.5964C10.1919 11.6654 10.2322 11.7275 10.2959 11.757L11.6312 12.3771C11.9051 12.5042 12.0796 12.7739 12.0796 13.0705V18.2636C12.0796 18.4492 11.9257 18.5996 11.7356 18.5996H1.22935C0.68837 18.5996 0.25 18.1714 0.25 17.6431V5.95647C0.25 5.42813 0.68837 5 1.22935 5ZM6.92772 14.0663C7.19566 14.0663 7.38668 14.031 7.50028 13.9608C7.62397 13.8901 7.68582 13.7594 7.68582 13.568V13.5376C7.68582 13.3362 7.61892 13.1949 7.48471 13.1143C7.36102 13.0338 7.14945 12.9936 6.85031 12.9936H4.8916V14.0663H6.92772ZM6.83517 10.3944C7.30975 10.3944 7.54705 10.2279 7.54705 9.89555V9.81994C7.54705 9.62847 7.4852 9.4974 7.36151 9.42716C7.24791 9.34663 7.05732 9.30637 6.78889 9.30637H4.89206V10.3944H6.83566H6.83517ZM12.9701 12.9484H17.2997C17.2997 13.2911 17.3616 13.5278 17.4853 13.6588C17.6195 13.7899 17.81 13.8552 18.0578 13.8552C18.4806 13.8552 18.6923 13.6185 18.6923 13.1448C18.6923 12.913 18.6199 12.7471 18.4756 12.646C18.3414 12.5453 18.1352 12.4948 17.8568 12.4948H15.4739V10.742L19.1407 9.85037H12.9701C12.7979 9.85037 12.6581 9.71392 12.6581 9.54571V5.25455C12.6581 5.11408 12.7749 5 12.9188 5H23.0696C23.6106 5 24.0489 5.42813 24.0489 5.95647V9.386C24.0489 9.77342 23.7763 10.1103 23.3907 10.2002L19.373 11.1352L19.5585 11.1657H23.393C23.8661 11.1657 24.25 11.5406 24.25 12.0026V17.6435C24.25 18.1719 23.8116 18.6 23.2707 18.6H12.9188C12.7749 18.6 12.6581 18.4859 12.6581 18.3455V13.253C12.6581 13.0849 12.7979 12.9484 12.9701 12.9484Z"
          fill="#11181C"
        />
      </g>
    </g>
    <defs>
      <clipPath id="clip0_5457_9838">
        <rect width="24" height="24" fill="white" transform="translate(0.25)" />
      </clipPath>
      <clipPath id="clip1_5457_9838">
        <rect
          width="24"
          height="13.6"
          fill="white"
          transform="translate(0.25 5)"
        />
      </clipPath>
    </defs>
  </svg>
)
